export default "__VITE_ASSET__ef3af8cb__"